import React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import StepCtaImageUrl from '#src/app/pages/local/details/shared/assets/sap.png';

export const StepCTA: React.FC = () => {
	const { translate } = useI18n();

	const steps = [
		{
			step: 1,
			heading: translate('corgi.local.steps_cta.step_1.heading'),
			subheading: translate('corgi.local.steps_cta.step_1.subheading'),
		},
		{
			step: 2,
			heading: translate('corgi.local.steps_cta.step_2.heading'),
			subheading: translate('corgi.local.steps_cta.step_2.subheading'),
		},
		{
			step: 3,
			heading: translate('corgi.local.steps_cta.step_3.heading'),
			subheading: translate('corgi.local.steps_cta.step_3.subheading'),
		},
	];

	return (
		<div className="flex flex-col gap-4">
			<div className="bg-background-raised flex flex-col-reverse justify-between gap-6 rounded-xl p-10 md:flex-row">
				<div className="text-typography-strong flex flex-col gap-6">
					{steps.map(({ step, heading, subheading }) => (
						<div className="flex flex-col gap-2" key={step}>
							<Text as="h3" variant="heading" size="small">
								{`${step}. ${heading}`}
							</Text>
							<Text>{subheading}</Text>
						</div>
					))}
				</div>

				<Image
					className="h-[234px] w-[257px] self-center rounded-xl object-cover"
					src={StepCtaImageUrl}
					alt={translate('corgi.local.steps_cta.image_alt')}
				/>
			</div>

			<div
				color="surface-secondary"
				className="bg-gradient-background-dark-3 flex flex-col rounded-xl p-10 max-lg:gap-10 md:flex-row md:items-center md:justify-between"
			>
				<Text as="h2" variant="heading" size="small" className="text-typography-inverse-strong">
					<Translate value="corgi.local.steps_cta.heading" />
				</Text>

				<Button
					variant="primary"
					className="max-md:mx-auto max-md:w-full"
					size="large"
					as="a"
					href="/start-a-petition/intro?source_location=local-cta"
					data-qa="footer-sap-button"
				>
					<Translate value="corgi.local.steps_cta.button" />
				</Button>
			</div>
		</div>
	);
};
